/**
 * Header / footer sütunları için varsayılan dahili link satırları (labelKey → common.json).
 */
export const DEFAULT_HEADER_NAV_LINKS = [
  { to: '/', labelKey: 'nav.home', end: true },
  { to: '/about', labelKey: 'nav.about' },
  { to: '/portfolio', labelKey: 'nav.portfolio' },
  { to: '/contact', labelKey: 'nav.contact' },
]

export const DEFAULT_FOOTER_MAIN_NAV_LINKS = [
  { to: '/about', labelKey: 'nav.about' },
  { to: '/portfolio', labelKey: 'nav.portfolio' },
  { to: '/contact', labelKey: 'nav.contact' },
]

export const DEFAULT_FOOTER_SOCIAL = [
  { href: 'https://linkedin.com/company/globalanka', label: 'LinkedIn', icon: 'linkedin', active: true },
  { href: 'https://instagram.com/globalanka', label: 'Instagram', icon: 'instagram', active: true },
  { href: 'https://wa.me/902125550199', label: 'WhatsApp', icon: 'whatsapp', active: true },
]
